module.exports = __webpack_public_path__ + "static/img/tianpin.111923e6.svg";